import { Theme } from "@mui/material";

export const NewsCenterTheme = (theme: Theme) => ({
  sideBarListItemHeader: {
    fontSize: "16px",
    opacity: 0.6
  }
});
